module.exports = __webpack_public_path__ + "img/f8.ac7b36f6.png";